import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { shareReplay, tap, catchError } from 'rxjs/operators';
import { Constants } from '../models/constants';
import { of } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { StorageService } from './storage.service';
@Injectable({
    providedIn: 'root',
})
export class RolesService {
    constructor(private http: HttpClient,private authService: MsalService,private storageService : StorageService) {}

    get(queryParams: any[]) {
        let params = new HttpParams();
        queryParams.forEach((param) => {
            params = params.set(param[0], param[1]);
        });
        const url = Constants.APP_BASE_API_URL + '/role/new';
        return this.http.get<any>(url, { params, responseType: 'json' });
    }

    getFilters() {
        const url = Constants.APP_BASE_API_URL + '/role/column-value';
        return this.http.get<any>(url, { responseType: 'json' });
    }

    getPermissions() {
        const url = Constants.APP_BASE_API_URL + '/role/default';
        return this.http.get<any>(url, { responseType: 'json' });
    }

    getRole() {
        const url = Constants.APP_BASE_API_URL + '/role/role-permissions';
        return this.http
            .get<any>(url, { responseType: 'json' })
            .pipe(shareReplay());
    }

    getPassPhrase(country) {
        const url = Constants.APP_BASE_API_URL + '/entity/global?Country='+country;
        // return this.http.get("assets/data/ksa/country.json");
        return this.http
             .get<any>(url, {responseType: 'json'});
    }


    checkValidKSAUser(){
        const url = Constants.GATEWAY_BASE_API_URL + '/validateKSAUser';
        // return of ({"data":"@GBL#EINV@"});
        return this.http.get<any>(url, {responseType: 'json'});
    }

    getAdminUser(){
        const url = Constants.KSA_ADMIN_BASE_API_URL + '/getAdminUser.do';
        // return of ({"data":"@GBL#EINV@"});
        const userName = this.authService?.instance?.getActiveAccount()?.username;
        let userEmail = userName?.length > 0 ? userName.toLowerCase() : this.storageService.deCodeJWT('preferred_username');
        const httpOptions = {
            headers: new HttpHeaders({
              'Username':  userEmail
            })
          };
    //     return of({hdr:{ 
    //         status:'S',
    //     },
    //         resp:[{groupCode:'a',groupName:'b'}]
    // })
        return this.http.post<any>(url, null,httpOptions);
    }


}
